export const CONTRACT_PRINT_ROOT = 'xsib-contract-print'

export const CONTRACT_PRINT_CSS = `
  .${CONTRACT_PRINT_ROOT} { display: none; }
  @media print {
    @page { size: A4 portrait; margin: 0; }
    html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    body > *:not(.${CONTRACT_PRINT_ROOT}) { display: none !important; }
    .${CONTRACT_PRINT_ROOT} { display: block; width: 210mm; }
    .${CONTRACT_PRINT_ROOT} * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
`

const IMAGE_WAIT_MS = 4000

export async function contractImagesSettled(): Promise<void> {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>(`.${CONTRACT_PRINT_ROOT} img`))
  const decodes = images.map((image) => image.decode().catch(() => undefined))
  const timeout = new Promise<void>((resolve) => setTimeout(resolve, IMAGE_WAIT_MS))
  await Promise.race([Promise.all(decodes).then(() => undefined), timeout])
}
